export default __webpack_public_path__ + "img/5ff8f45bec81f038dc8950157404e186.png";